import { render, staticRenderFns } from "./SplitAccountDetail.vue?vue&type=template&id=edc1f68a&scoped=true"
import script from "./SplitAccountDetail.vue?vue&type=script&lang=js"
export * from "./SplitAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./SplitAccountDetail.vue?vue&type=style&index=0&id=edc1f68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc1f68a",
  null
  
)

export default component.exports